import React, { Component } from 'react';

import { Link } from 'react-router';
import Lottie from "react-lottie";
import $ from 'jquery'

import LoadingData from "../../../../assets/animations/loading.json";

import Navbar from '../navbar/navbar';

export default class Header extends Component {

	toggleMenu = () => {
		if($("#bodyRoot").hasClass("sidebar-collapse")) {
			$("#bodyRoot").removeClass("sidebar-collapse");
		} else {
			$("#bodyRoot").addClass("sidebar-collapse");
		}

		if($("#bodyRoot").hasClass("sidebar-open")) {
			$("#bodyRoot").removeClass("sidebar-open");
		} else {
			$("#bodyRoot").addClass("sidebar-open");
		}

	}

	renderLottie = () => {
		return (
			<div style={{display: 'inline-block', marginTop: '.6rem'}}>
				<Lottie
					options={{
						loop: true,
						autoplay: true,
						animationData: LoadingData,
						rendererSettings: {
							preserveAspectRatio: "xMidYMid slice"
						}
					}}
					height={35}
					width={35}
				/>
			</div>
			
		)
	}

	render() {
		return (
			<header className="main-header">
				<Link to="/" className="logo">
					<span className='logo-mini'>
						<i className="icon icon-uniastro"></i>
					</span>
					<span className="logo-lg" style={{marginRight: 44}}>
						<i className="icon icon-uniastro"></i>
						<strong style={{ verticalAlign: "top"}}> Uniastro</strong>
					</span>
				</Link>
				<nav className='navbar navbar-static-top'>
					<div className='sidebar-toggle' data-toggle='offcanvas' onClick={this.toggleMenu}></div>
					<Navbar />
				</nav>
			</header>
		);
	}
}